import { NeutralColor } from "node-library/dist/colors";

interface IconProps {
	size?: number;
	strokeColor?: string;
	fillColor?: string;
}

function SidebarOrderIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_400;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M21 6.81813L3.00117 6.81788L3 6.81818M21 6.81813L20.9994 18.9236C20.9994 20.0704 20.0226 21 18.8177 21H5.18175C3.9768 21 3 20.0704 3 18.9236V6.81818M21 6.81813L17.3915 3.31952C17.1806 3.11493 16.8944 3 16.5961 3H7.40334C7.10498 3 6.81885 3.11493 6.60787 3.31952L3 6.81818M15.3746 10.0909C15.3746 11.8984 13.8636 13.3636 11.9997 13.3636C10.1358 13.3636 8.62481 11.8984 8.62481 10.0909"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function SidebarProfileIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M3.23779 19.5C4.5632 17.2892 7.46807 15.7762 12.0001 15.7762C16.5321 15.7762 19.4369 17.2892 20.7623 19.5M15.6001 8.1C15.6001 10.0882 13.9883 11.7 12.0001 11.7C10.0118 11.7 8.40007 10.0882 8.40007 8.1C8.40007 6.11177 10.0118 4.5 12.0001 4.5C13.9883 4.5 15.6001 6.11177 15.6001 8.1Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function SidebarSignoutIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.2243 3.32815L13.3752 3.12674L13.3947 3.12333C13.9243 3.03064 14.3491 2.95631 14.695 2.92177C15.0485 2.88646 15.3647 2.88712 15.6686 2.97146C16.3667 3.16522 16.9464 3.65229 17.2576 4.30655C17.3931 4.59132 17.4482 4.90269 17.4744 5.25703C17.5 5.6037 17.5 6.03489 17.5 6.57262L17.5 6.59235V13.5462L17.5 13.5636C17.5 14.0394 17.5 14.421 17.4798 14.7287C17.4593 15.043 17.4159 15.3202 17.3092 15.5776C16.9974 16.329 16.3395 16.8818 15.5455 17.0594C15.2737 17.1201 14.9931 17.115 14.68 17.0811C14.3734 17.048 13.9975 16.9822 13.5288 16.9001L13.5117 16.8971L12.2243 16.6718L12.192 16.6662C11.4284 16.5326 10.8097 16.4243 10.3258 16.2763C9.82184 16.122 9.40579 15.9085 9.08592 15.5278C8.76606 15.1471 8.62744 14.7005 8.56241 14.1774C8.49998 13.6753 8.49999 13.0472 8.5 12.272V12.2392V7.76079V7.72798C8.49999 6.95284 8.49998 6.32472 8.56241 5.82256C8.62744 5.29953 8.76606 4.8529 9.08592 4.47219C9.40579 4.09149 9.82184 3.87796 10.3258 3.72374C10.8097 3.57568 11.4284 3.46741 12.192 3.33381L12.2243 3.32815Z"
				stroke="#7D7D7D"
				strokeWidth="1.2"
			/>
			<path
				d="M2 10L1.57574 9.57574L1.15147 10L1.57574 10.4243L2 10ZM11 10.6C11.3314 10.6 11.6 10.3314 11.6 10C11.6 9.66863 11.3314 9.4 11 9.4V10.6ZM5.57574 5.57574L1.57574 9.57574L2.42426 10.4243L6.42426 6.42426L5.57574 5.57574ZM1.57574 10.4243L5.57574 14.4243L6.42426 13.5757L2.42426 9.57574L1.57574 10.4243ZM2 10.6H11V9.4H2V10.6Z"
				fill="#7D7D7D"
				strokeWidth="1.3"
			/>
		</svg>
	);
}

function SidebarRosterIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M2.3999 18.2168C3.49855 16.3843 5.90641 15.1301 9.66302 15.1301C13.4196 15.1301 15.8275 16.3843 16.9261 18.2168M17.6211 13.7406C19.6105 14.7352 20.6052 15.7299 21.5999 17.7193M15.5521 6.1376C16.4882 6.64115 17.1245 7.62991 17.1245 8.7673C17.1245 9.87183 16.5244 10.8362 15.6325 11.3522M12.6471 8.76727C12.6471 10.4153 11.3111 11.7513 9.66302 11.7513C8.01496 11.7513 6.67895 10.4153 6.67895 8.76727C6.67895 7.11922 8.01496 5.7832 9.66302 5.7832C11.3111 5.7832 12.6471 7.11922 12.6471 8.76727Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function SidebarOrganizationIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M7.5 17.0625H16.5M11.3046 3.21117L3.50457 8.48603C3.18802 8.7001 3 9.04666 3 9.41605V19.2882C3 20.2336 3.80589 21 4.8 21H19.2C20.1941 21 21 20.2336 21 19.2882V9.41605C21 9.04665 20.812 8.7001 20.4954 8.48603L12.6954 3.21117C12.2791 2.92961 11.7209 2.92961 11.3046 3.21117Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function SidebarInfoIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M11.9991 15.375V12M11.9991 8.625V8.70959M20.9983 12C20.9983 13.2938 20.7253 14.5238 20.2338 15.6356L21 
				20.9991L16.4039 19.85C15.1019 20.5823 13.5993 21 11.9991 21C7.02906 21 3 16.9706 3 12C3 7.02944 7.02906 3
				 11.9991 3C16.9692 3 20.9983 7.02944 20.9983 12Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function HeaderLanguageIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M20.4375 12.75C20.8517 12.75 21.1875 12.4142 21.1875 12C21.1875 11.5858 20.8517 11.25 20.4375 
				11.25V12.75ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 
				20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 
				7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 
				6.61522 17.3848 2.25 12 2.25V3.75ZM12 20.25C11.7045 20.25 11.3639 20.1163 10.9886 19.7535C10.6098 19.3873 10.2344 18.8211 
				9.90288 18.0633C9.24079 16.55 8.8125 14.4069 8.8125 12H7.3125C7.3125 14.5637 7.76565 16.9206 8.52865 18.6646C8.90966 19.5355 
				9.38272 20.2873 9.94605 20.8319C10.513 21.3801 11.2082 21.75 12 21.75V20.25ZM8.8125 12C8.8125 9.59314 9.24079 7.45001 9.90288 
				5.93665C10.2344 5.17886 10.6098 4.61271 10.9886 4.24648C11.3639 3.88373 11.7045 3.75 12 3.75V2.25C11.2082 2.25 10.513 2.61995 9.94605 
				3.16805C9.38272 3.71267 8.90966 4.46454 8.52865 5.33542C7.76565 7.07943 7.3125 9.4363 7.3125 12H8.8125ZM12 21.75C12.7918 21.75 13.487 
				21.3801 14.054 20.8319C14.6173 20.2873 15.0903 19.5355 15.4714 18.6646C16.2344 16.9206 16.6875 14.5637 16.6875 12H15.1875C15.1875 14.4069 
				14.7592 16.55 14.0971 18.0633C13.7656 18.8211 13.3902 19.3873 13.0114 19.7535C12.6361 20.1163 12.2955 20.25 12 20.25V21.75ZM16.6875 12C16.6875 
				9.4363 16.2344 7.07943 15.4714 5.33542C15.0903 4.46454 14.6173 3.71267 14.054 3.16805C13.487 2.61995 12.7918 2.25 12 2.25V3.75C12.2955 
				3.75 12.6361 3.88373 13.0114 4.24648C13.3902 4.61271 13.7656 5.17886 14.0971 5.93665C14.7592 7.45001 15.1875 9.59314 15.1875 12H16.6875ZM3 
				12.75L20.4375 12.75V11.25L3 11.25L3 12.75Z"
				fill="black"
			/>
		</svg>
	);
}

function HeaderNotificationIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M9.33333 20.0909C10.041 20.6562 10.9755 21 12 21C13.0245 21 13.959 20.6562 14.6667 20.0909M4.50763 17.1818C4.08602 
				17.1818 3.85054 16.5194 4.10557 16.1514C4.69736 15.2975 5.26855 14.0451 5.26855 12.537L5.29296 10.3517C5.29296 6.29145 
				8.29581 3 12 3C15.7588 3 18.8058 6.33993 18.8058 10.4599L18.7814 12.537C18.7814 14.0555 19.3329 15.3147 19.9006 
				16.169C20.1458 16.5379 19.9097 17.1818 19.4933 17.1818H4.50763Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function HeaderQuestionIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M11.9991 15.375V12M11.9991 8.625V8.70959M20.9983 12C20.9983 13.2938 20.7253 14.5238 20.2338 15.6356L21 
				20.9991L16.4039 19.85C15.1019 20.5823 13.5993 21 11.9991 21C7.02906 21 3 16.9706 3 12C3 7.02944 7.02906 3
				 11.9991 3C16.9692 3 20.9983 7.02944 20.9983 12Z"
				stroke="#121212"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export {
	SidebarOrderIcon,
	SidebarProfileIcon,
	SidebarSignoutIcon,
	SidebarRosterIcon,
	SidebarOrganizationIcon,
	SidebarInfoIcon,
	HeaderLanguageIcon,
	HeaderNotificationIcon,
	HeaderQuestionIcon,
};
